<template>
  <q-form @submit="this.onSubmit" class="form">
    <div class="form__item">
      <CustomInput
        label="Название группы работ"
        type="text"
        :required="true"
        :value="formData.work_group_name"
        @change_input="(value) => onChange('work_group_name', value)"
        autofocus
        style="width: 100%;"
      />
    </div>
    <div class="form__item">
      <q-checkbox
        v-model="formData.is_level_need"
        label="Требуется этаж"
        color="primary"
      />
    </div>
    <CustomModalFooter :btn-loading="this.loading" />
  </q-form>
</template>

<script>
import CustomInput from "@/components/form/CustomInput";
import CustomModalFooter from "@/components/modal/modals/modal-footer";

export default {
  name: "AddWorkGroupDict",
  components: { CustomInput, CustomModalFooter },
  props: ['data', 'closeModal'],
  data() {
    return {
      loading: false,
      formData: {
        work_group_dict_id: this.data?.workGroup?.work_group_dict_id || null,
        work_group_name: this.data?.workGroup?.work_group_name || '',
        is_level_need: this.data?.workGroup?.is_level_need || false,
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      if (!this.formData.work_group_name || !this.formData.work_group_name.trim()) {
        return;
      }
      this.loading = true
      const res = await this.data?.onSubmit(this.formData)
      this.loading = false
      if (res !== false) {
        this.closeModal?.()
      }
    },
  }
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  width: 400px;
  gap: 15px;

  &__item {
    width: 100%;
    display: flex;
    gap: 16px;

    :deep(.custom-input) {
      width: 100%;
      max-width: 100%;
    }
  }

  @media (max-width: 460px) {
    width: 100%;
  }
}
</style>

